import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreComponent,storeBookDialog,selectCountryAndLanguage } from './store.component';
import { DependentModule } from "../shared/dependent.module";
import { StoreFilterComponent } from './store-filter/store-filter.component';
import { StorePouchDb } from './store.pouchdb.service';
import { CountrydetailsComponent } from './popups/countrydetails/countrydetails.component';
import {ArraySortPipe} from './sequenceByOrder'
import { StoreBookDetailsComponent } from './popups/storeBookDetails/storeBookDetails.component';
import { StoreSearchResultsComponent } from './popups/storeSearchResults/storeSearchResults.component'
import { CircleProgressComponent } from '../shared/CircleProgress/CircleProgress.component'

@NgModule({
  imports: [
    CommonModule,
    DependentModule
  ],
  declarations: [StoreComponent, StoreFilterComponent, CountrydetailsComponent, ArraySortPipe, StoreBookDetailsComponent, storeBookDialog, selectCountryAndLanguage, StoreSearchResultsComponent, CircleProgressComponent],
  entryComponents: [StoreComponent, StoreFilterComponent, CountrydetailsComponent, StoreBookDetailsComponent, storeBookDialog, selectCountryAndLanguage, StoreSearchResultsComponent, CircleProgressComponent],
  providers: [StorePouchDb]

})
export class StoreModule { }


// WEBPACK FOOTER //
// ./src/app/store/store.module.ts